export default __webpack_public_path__ + "static/media/read.104c6727.jpg";